// Stamped by scripts/write-release.mjs when GITHUB_SHA or .preview-client-id is
// present. These committed values are the local and unit-test defaults.
// releaseVersion matches the Datadog sourcemap upload (`github.sha`).
// previewClientId is the ephemeral Sirius client for a PR preview.
export const releaseVersion = '6d976b01553c0af354e47a1f07cc5d022c51afdc';
export const previewClientId = 'future-room-preview-future-room-6-mmhi1bva';
